import React from 'react'
import { connect } from 'react-redux'
import { Modal, Button } from 'semantic-ui-react'
import { SCCont, SCContDetail } from './styled'
import { StdCard, StatusTag } from 'components'
import { getVendorEmail } from 'ducks/codeOfConduct'

const VendorInfo = (props) => {
  const { data, vendorStatus } = props

  React.useEffect(() => {
    if (data.vendorCode) {
      props.getVendorEmail(data.vendorCode)
    }
  }, [data && data.vendorCode])

  const [showViewVendorEmail, setShowViewVendorEmail] = React.useState(false)

  return (
    <StdCard title='Vendor information' fitContent={false} style={{ marginTop: '1rem' }}>
      <SCCont>
        <SCContDetail style={{ marginTop: '0px' }}>
          <div>
            <div style={{ display: 'flex' }}>
              <b>{data.vendorCode} | {data.vendorName}</b>
              {data.isBlock ? <StatusTag style={{ marginLeft: '5px' }} status={6} statusName='Block' /> : null}
            </div>
            <p>{data.vendorAddress}</p>
          </div>
          <div style={{ textAlign: 'right' }}><b>Tax Id: </b>{data.vendorTax}</div>
        </SCContDetail>
        <SCContDetail>
          <div><b>EzProcure Registration: </b> {vendorStatus.registered ? 'Yes' : 'No'}</div>
          <div>
            {
              vendorStatus.registered ?
                <Button
                  type='button'
                  content='View Email'
                  icon='envelope'
                  labelPosition='right'
                  floated='right'
                  style={{ marginRight: '0.3125rem' }}
                  onClick={() => setShowViewVendorEmail(true)}
                /> : null
            }
          </div>
        </SCContDetail>
        <SCContDetail>
          <div><b>Contact information</b></div>
        </SCContDetail>
        <SCContDetail style={{ flexDirection: 'column' }}>
          <div style={{ display: 'flex', width: '100%', flexDirection: 'row', marginLeft: '0px' }}>
            <div style={{ display: 'flex', flex: 1 }}><i class='user icon' style={{ color: ' #FFD700' }} /></div>
            <div style={{ display: 'flex', flex: 1 }}><i class='envelope icon' style={{ color: ' #FFD700' }} /></div>
            <div style={{ display: 'flex', flex: 1 }}><i class='phone icon' style={{ color: ' #FFD700' }} /></div>
          </div>
          {
            (data.contactInfo || []).map((item) =>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row', marginLeft: '0px' }}>
                <div style={{ display: 'flex', flex: 1, marginTop: '10px' }}>{item.firstname} {item.lastname}</div>
                <div style={{ display: 'flex', flex: 1, marginTop: '10px' }}>{item.email}</div>
                <div style={{ display: 'flex', flex: 1, marginTop: '10px' }}>{item.telephone}</div>
              </div>
            )
          }
        </SCContDetail>
      </SCCont>
      <Modal
        onClose={() => setShowViewVendorEmail(false)}
        open={showViewVendorEmail}
        size='medium'
      >
        <Modal.Header>Vendor Email</Modal.Header>
        <Modal.Content>
          <div className='content' style={{ display: 'flex', flexDirection: 'column' }}>
            {vendorStatus && vendorStatus.emails ? vendorStatus.emails.map((item) => {
              return <b>{item}</b>
            }) : null}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content='Close'
            onClick={() => setShowViewVendorEmail(false)}
            color='green'
          />
        </Modal.Actions>
      </Modal>
    </StdCard>
  )

}

const mapStateToProps = (state) => ({
  vendorStatus: state.codeOfConduct.vendorStatus,
})
const mapDispatchToProps = {
  getVendorEmail
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorInfo)
